import { useQuery } from '@tanstack/react-query'
import { useCallback } from 'react'
import { levelService } from '../../../services/level'
import { setGraphClientAuthToken } from '../../../services/graph-client'
import { useGetMyProfile } from '../profile/use-get-my-profile'

export const USER_LEVEL_STATUS_QUERY_KEY = ['getUserLevelStatus']

export const useGetUserLevelStatus = (options?: { token?: string | null; enabled?: boolean }) => {
  const { user } = useGetMyProfile()

  const { data, isLoading, refetch } = useQuery({
    queryKey: [...USER_LEVEL_STATUS_QUERY_KEY, user?.id],
    staleTime: 0,
    enabled: (options?.enabled ?? true) && Boolean(user?.id),
    queryFn: () => {
      setGraphClientAuthToken(options?.token)
      return levelService.getUserLevelStatus({ userId: Number(user?.id) })
    },
  })

  const get = useCallback(async () => {
    const levelStatus = await refetch()
    return levelStatus?.data?.data
  }, [refetch])

  return {
    levelStatus: data?.data,
    isLoading,
    get,
  }
}
